import { combineReducers } from "redux";
import authReducer from "./AuthReducer";
export const reducers = combineReducers({authReducer});